
import { StoreApi } from 'zustand';
import { PriceState } from '../../types';
import { UserState } from '../../../auth/userSlice';
import { notificationService } from '@/services/notifications/notificationService';
import { sendEmail } from '@/services/email/emailService';

type GetPriceState = () => PriceState & UserState;
type SetPriceState = StoreApi<PriceState & UserState>["setState"];

export const checkPriceAlerts = async (
  set: SetPriceState,
  get: GetPriceState
) => {
  const state = get();
  const { priceAlerts, currentGoldPrice, currentSilverPrice, user } = state;

  console.log('[checkPriceAlerts] Checking alerts:', { 
    alertsCount: priceAlerts.length,
    hasGoldPrice: !!currentGoldPrice,
    hasSilverPrice: !!currentSilverPrice
  });

  if (!priceAlerts.length || (!currentGoldPrice && !currentSilverPrice)) {
    console.log('[checkPriceAlerts] No alerts to check or no prices available');
    return;
  }

  // Process each active alert
  for (const alert of priceAlerts) {
    if (!alert.isActive) {
      continue;
    }

    const currentPrice = alert.metal === 'gold' 
      ? currentGoldPrice?.price 
      : currentSilverPrice?.price;

    if (!currentPrice) {
      console.log(`[checkPriceAlerts] Missing price data for ${alert.metal}`);
      continue;
    }

    const isTriggered = alert.condition === 'above'
      ? currentPrice >= alert.targetPrice
      : currentPrice <= alert.targetPrice;

    if (isTriggered) {
      console.log('[checkPriceAlerts] Alert triggered:', { 
        alertId: alert.id,
        metal: alert.metal,
        targetPrice: alert.targetPrice,
        currentPrice
      });
      
      const title = "Avviso Prezzo Raggiunto!";
      const message = `Il prezzo ${alert.metal === 'gold' ? "dell'oro" : "dell'argento"} ha raggiunto €${alert.targetPrice.toFixed(2)}`;
      const url = window.location.origin + "/avvisi";

      try {
        await notificationService.sendNotification(title, message, url);
        console.log('[checkPriceAlerts] Notification sent successfully');
      } catch (notificationError) {
        console.error('[checkPriceAlerts] Error sending notification:', notificationError);
      }

      if (user?.email) {
        try {
          await sendEmail({
            to: user.email,
            subject: "Avviso Prezzo Gildy",
            body: `
              <h1>Il tuo target di prezzo è stato raggiunto!</h1>
              <p>Il prezzo ${alert.metal === 'gold' ? "dell'oro" : "dell'argento"} 
              ha raggiunto €${alert.targetPrice.toFixed(2)}.</p>
              <p>Accedi a Gildy per visualizzare i dettagli.</p>
            `,
            isHtml: true
          });
          console.log('[checkPriceAlerts] Email notification sent');
        } catch (emailError) {
          console.error('[checkPriceAlerts] Error sending price alert email:', emailError);
        }
      }

      // Deactivate the triggered alert
      set((state: PriceState & UserState) => ({
        priceAlerts: state.priceAlerts.map(a => 
          a.id === alert.id ? { ...a, isActive: false } : a
        )
      }));
      
      console.log('[checkPriceAlerts] Alert deactivated:', alert.id);
    }
  }
};
